<div class="filters-row">
  <app-aggregated-filter
    [fixedFilters]="fixedFilters"
    [filterTypes]="filters"
    (filtersChanged)="onAggregatedFiltersChanged($event)"
  />
  <app-content-view-type-selector (viewTypeChange)="viewType.set($event)" />
</div>
<div class="actions-row">
  <div>
    <app-filters-row
      [interactor]="getTypesInteractor"
      [type]="FilterType.PublicationStatus"
      (optionSelected)="statusFilter.set($event)"
    />
    <app-sorting-selector
      [options]="sortingOptions"
      (optionSelected)="sortBy.set($event)"
    />
  </div>
  @if (campaign.isEditable) {
    <button (click)="gotToContentCreation()" class="btn btn--primary">
      <mat-icon>add</mat-icon>
      {{ "publicationTemplates.create" | translate }}
    </button>
  }
</div>

@if (isThereNoContent() && areFiltersPristine()) {
  <app-reload
    buttonKey="publicationTemplates.create"
    textKey="campaign.content.errorNoContent"
    (action)="gotToContentCreation()"
  />
} @else {
  @switch (viewType()) {
    @case (ContentViewType.Grid) {
      <app-brand-publication-tiles
        [filters]="activeFilters()"
        [sorting]="sortBy()"
        (noContent)="isThereNoContent.set(true)"
        [isInitialized]="isInitialized()"
        (resetFilters)="resetFilters()"
      />
    }
    @case (ContentViewType.List) {
      <app-brand-publication-list
        [filters]="activeFilters()"
        [isInitialized]="isInitialized()"
        [sorting]="sortBy()"
        (noContent)="isThereNoContent.set(true)"
        (resetFilters)="resetFilters()"
      />
    }
    @case (ContentViewType.Calendar) {
      <app-brand-publication-calendar
        [filters]="activeFilters()"
        [isInitialized]="isInitialized()"
        [sorting]="sortBy()"
        (noContent)="isThereNoContent.set(true)"
        (resetFilters)="resetFilters()"
      />
    }
  }
}
